module.exports = __webpack_public_path__ + "static/media/Logo-Bloclit-v1-alb.bcb82968.png";